module.exports = __webpack_public_path__ + "static/img/icon6.a2bf9b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/icon6.png
// module id = yPeB
// module chunks = 1